<template>
<v-layout fluid fill-height>
    <v-flex row wrap>
        <v-card min-height="100px" min-width="100px" height="100%">
            <v-layout row wrap>
                <v-flex xs6 text-xs-left>
                    <h2>{{PlantName}}: {{DivisionName}}</h2>
                    <h1>Location: {{LocationName}}</h1>
                </v-flex>
                <v-flex xs6 text-xs-right>
                    <v-btn large color="success" @click="SaveBtnClicked" :disabled="Loading">Save &amp; Close</v-btn>
                    <v-btn large color="error" @click="CancelBtnClicked" :disabled="Loading">Cancel &amp; Close</v-btn>
                </v-flex>
            </v-layout>
            <v-progress-linear :indeterminate="true" :active="Loading"></v-progress-linear>
            <div class="MapContainer">
                <div class="Overlay" v-if="Loading"></div>
                <OkPopup :DisplayDialog="DisplayDialog" :DialogTitle="'Something went wrong'" :DialogContents="DialogText" @ClickedOK="DisplayDialog = false" />
                <div id="editMap"></div>
            </div>
        </v-card>
    </v-flex>
</v-layout>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import locationApi from '../../api/locationApi'
import OkPopup from '../../components/generic/OkPopup'
export default {
    components: {
        OkPopup
    },
    data() {
        return {
            LocationID: -1,
            LocationGeoData: null,
            LocationName: '',
            DivisionName: '',
            PlantName: '',
            Loading: false,
            DisplayDialog: false,
            DialogText: ''
        };
    },
    created() {
        let l_locationID = this.$route.params.LocationID;
        if (l_locationID && l_locationID > 0) {
            this.LocationID = l_locationID;
        }
    },
    methods: {
        async SetupMap() {
            mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
            let l_this = this;

            if (this.LocationGeoData) {

                let l_locationGeoData = this.LocationGeoData;
                let l_centre;

                if (l_locationGeoData.features[0].geometry) {
                    l_centre = l_locationGeoData.features[0].geometry.coordinates[0][0];
                } else {
                    let lat = l_locationGeoData.features[0].properties.PlantCentre.Lat;
                    let long = l_locationGeoData.features[0].properties.PlantCentre.Long;
                    l_centre = [long, lat];
                }

                var map = new mapboxgl.Map({
                    container: 'editMap',
                    style: 'mapbox://styles/mapbox/satellite-v9',
                    minzoom: 1.3,
                    center: l_centre,
                    zoom: 14
                });

                var draw = new MapboxDraw({
                    displayControlsDefault: false,
                    controls: {
                        polygon: true,
                        trash: true
                    }
                });

                map.addControl(draw);

                map.on('draw.create', updateArea);
                map.on('draw.delete', updateArea);
                map.on('draw.update', updateArea);

                if (l_locationGeoData.features[0].geometry) {
                    draw.add(l_locationGeoData);
                }

                // eslint-disable-next-line
                function updateArea() {
                    let data = draw.getAll();

                    if (data.features.length <= 0) {
                        //no poly's - if we save now, all location geo data would be deleted
                    } else if (data.features.length > 1) {
                        //delete all but first item
                        let i;
                        for (i = 1; i < data.features.length; i++) {
                            draw.delete(data.features[i].id); //remove from map
                        }
                        data.features.splice(1); //remove from result object
                    } else {
                        //we got one - all good
                    }
                    l_this.SetNewGeoData(data);
                }
            }
        },
        async SaveBtnClicked() {
            this.Loading = true;
            try {
                let result = await locationApi.setLocationGeoJSONData(this.LocationID, this.LocationGeoData);
                if (result == true) {
                    this.ClosePopup();
                } else {
                    this.DialogText = 'An error has occured while updating this location. Please try again.';
                    this.DisplayDialog = true;
                    this.Loading = false;
                }
            } catch (err) {
                this.DialogText = 'An error has occured while updating this location. Please try again.';
                this.DisplayDialog = true;
                this.Loading = false;
                console.log(err.toString());
            }
        },
        CancelBtnClicked() {
            this.ClosePopup();
        },
        SetNewGeoData(p_geoData) {
            this.LocationGeoData = p_geoData;
        },
        ClosePopup() {
            try {
                parent.CloseRadWindow();
            } catch (err) {
                this.DialogText = 'An error has occured while updating this location. Please try again.';
                this.DisplayDialog = true;
                this.Loading = false;
                console.log(err.toString());
            }
        }
    },
    async mounted() {
        if (this.LocationID && this.LocationID > 0) {
            this.LocationGeoData = await locationApi.getLocationGeoJSONData(this.LocationID);
            this.LocationName = this.LocationGeoData.features[0].properties.LocationName;
            this.DivisionName = this.LocationGeoData.features[0].properties.DivisionName;
            this.PlantName = this.LocationGeoData.features[0].properties.PlantName;
        }
        this.SetupMap();
    }
}
</script>

<style>
@import 'https://api.mapbox.com/mapbox-gl-js/v0.53.0/mapbox-gl.css';
@import 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.css';

#editMap {
    position: relative;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 89%;
}

div.Overlay {
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.5;
    position: absolute;
    z-index: 5;
}

div.MapContainer {
    width: 100%;
    height: 100%;
}
</style>
